<div class="modal fade" id="modalReference" tabindex="-1" aria-labelledby="modalReferenceLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalReferenceLabel">Referencia</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Nombre</label>
                            <div>
                                <input formControlName="firstName" type="text" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('firstName')?.invalid && (form.get('firstName')?.touched || form.get('firstName')?.dirty)}"/>
                                @if (form.get('firstName')?.invalid && (form.get('firstName')?.touched || form.get('firstName')?.dirty)) {
                                    @if (form.get('firstName')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('firstName')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('firstName')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Apellido</label>
                            <div>
                                <input formControlName="lastName" type="text" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('lastName')?.invalid && (form.get('lastName')?.touched || form.get('lastName')?.dirty)}"/>
                                @if (form.get('lastName')?.invalid && (form.get('lastName')?.touched || form.get('lastName')?.dirty)) {
                                    @if (form.get('lastName')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('lastName')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('lastName')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                         <div class="form-group mb-3">
                            <label class="required-field">Empresa</label>
                            <div>
                                <app-dropdown [options]="companies" formControlName="companyId"></app-dropdown>
                                @if (form.get('companyId')?.invalid && (form.get('companyId')?.touched || form.get('companyId')?.dirty)) {
                                    @if (form.get('companyId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Posición</label>
                            <div>
                              <app-dropdown [options]="positions" formControlName="positionId"></app-dropdown>
                              @if (form.get('positionId')?.invalid && (form.get('positionId')?.touched || form.get('positionId')?.dirty)) {
                                    @if (form.get('positionId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                              }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Teléfono</label>
                            <div>
                                <input formControlName="phone" type="text" class="form-control" 
                                mask="(000)-000-0000" [dropSpecialCharacters]="false"
                                [ngClass]="{'is-invalid': form.get('phone')?.invalid && (form.get('phone')?.touched || form.get('phone')?.dirty)}"/>
                                @if (form.get('phone')?.invalid && (form.get('phone')?.touched || form.get('phone')?.dirty)) {
                                    @if (form.get('phone')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('phone')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('phone')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Correo electrónico</label>
                            <div>
                                <input formControlName="email" type="email" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('email')?.invalid && (form.get('email')?.touched || form.get('email')?.dirty)}"/>
                                @if (form.get('email')?.invalid && (form.get('email')?.touched || form.get('email')?.dirty)) {
                                    @if (form.get('email')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('email')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('email')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                    @if (form.get('email')?.hasError('email')) {
                                        <div class="invalid-feedback">
                                            El formato del correo electrónico es incorrecto
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button (click)="submit()" type="button" class="btn btn-primary">
                        @if(!isLoading()){
                            Guardar
                        }@else {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Guardando
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>